export const SHOW_RENAME_MODAL = 'SHOW_RENAME_MODAL';
export const CLOSE_RENAME_MODAL = 'CLOSE_RENAME_MODAL';
export const CHANGE_PAGE = "CHANGE_PAGE";
export const SORT_COLUMN = "SORT_COLUMN";
export const SET_DISPLAY_MODE = "SET_DISPLAY_MODE";
export const SET_EXPAND_ID = "SET_EXPAND_ID";